<app-user-plus *ngIf="isHabilitarAddAvalista" class="user-enabled" (onClick)="abrirInclusaoAvalista()"></app-user-plus>

<app-avalista [idFicha]="idFicha" [cpfCliente]="this.proposta.cliente.cpf"></app-avalista>
